import { useMutation } from '@tanstack/react-query'
import uploadResource from './api/resource/uploadResource'

const useUploadResource = () => {
  const { mutateAsync, isPending, error } = useMutation({
    mutationFn: async (params: { data: Blob; extension: string }): Promise<string> => uploadResource(params),
  })

  return { upload: mutateAsync, isPending, error }
}

export default useUploadResource
